// extracted by mini-css-extract-plugin
export default {"container":"ThankYou-index__container--nxX2M","tickIcon":"ThankYou-index__tickIcon--x3Buc","thankYouText":"ThankYou-index__thankYouText--nWPb6"};